import React, { useContext, useRef, useState } from 'react';
import { TeApiContext, useSelector } from '@ecommerce/nest-ssr/common';
import Button from 'atomic/button';
import SearchOptionInterface from 'layouts/header/search/search-option.interface';
import Autosuggest from 'layouts/header/search/components/autosuggest';
import Icon from 'atomic/icon';
import Dropdown from 'atomic/dropdown/dropdown';

export interface SelectOptionInterface {
    value: string;
    label: string;
}

import './search.scss';

const Search: React.FC<{
    onFocusSearch?: () => void;
    onBlurSearch?: () => void;
}> = ({ onFocusSearch, onBlurSearch }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const selectOptions: SelectOptionInterface[] = [];
    const allCategorysOption: SelectOptionInterface = { value: '', label: 'Wszystkie kategorie' };

    const options = useSelector(
        (state: { departments: SearchOptionInterface[]; }) => state.departments || []
    );

    const { selected, query } = useSelector(
        (state: { search: { selected: SelectOptionInterface; query: string; }; }) => state.search || {}
    );

    options.forEach(item => {
        selectOptions.push({
            value: item.id,
            label: item.name
        });
    });

    const selectedValue = selected || allCategorysOption;
    const items = [allCategorysOption, ...selectOptions];

    if (selected) {
        items.unshift(selected);
    }

    const [searchValue, setSearchValue] = useState(query || '');
    const [categoryId, setCategoryId] = useState(selectedValue.value);
    const formRef = useRef<any>(null);

    const onChange = (event: any, { newValue }: any): void => setSearchValue(newValue);

    const onSubmit = (): void => formRef.current.submit();

    const handleSubmit = (event: React.FormEvent): void => {
        if (searchValue.trim().length === 0) {
            event.preventDefault();
        }
    };

    return (
        <div className={`search-content${api.getDevice() === 'desktop' ? '' : ' search-content--mobile'}`}>
            <form className="search-content__form" action="/szukaj" method="get"
                ref={formRef} onSubmit={handleSubmit}
            >
                <div className="search-content__form__group">
                    <Autosuggest
                        searchValue={searchValue}
                        selectedValue={selectedValue}
                        onSubmit={onSubmit}
                        onChange={onChange}
                        onFocus={onFocusSearch}
                        onBlur={onBlurSearch}
                    />
                    <div className="search-content__form__group__categories">
                        <Dropdown
                            className="search-categories"
                            list={items}
                            defaultValue={selectedValue.value}
                            isTransparent={true}
                            onChange={setCategoryId}
                        />
                        <input
                            type="hidden"
                            name="categoryId"
                            value={categoryId}
                        />
                    </div>
                    <Button className="search-content__form__group__submit" type="submit" color="yellow"
                        uppercase={true} title="Wyszukaj" aria-label="Wyszukaj"
                    >
                        <Icon name="search" color="secondary" size={18} />
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default Search;
